import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import SelectablePKey from "./pkeys/SelectablePKey";
import AudioKey from "../lib/AudioKey";

import "./PKeyApp.scss";

function PKeyApp() {
	const location = useLocation();

	useEffect(() => {
		if (/\/embed$/.test(location.pathname)) {
			document.documentElement.classList.add("embed");
		} else {
			document.documentElement.classList.remove("embed");
		}
	}, [location]);

	return (
		<div className="pkey-app-container">
			<SelectablePKey />
			<SelectablePKey defaultKeyNumber={(new AudioKey(9, 0)).number()} />
			<SelectablePKey defaultKeyNumber={(new AudioKey(10, 5)).number()} />
			<SelectablePKey defaultKeyNumber={(new AudioKey(7, 1)).number()} />
		</div>
	);
}

export default PKeyApp;
